const base = 'bbraun-ui-sidebar';

export const SIDEBAR_DATA_TEST = {
  sidebar: { selector: `${base}:sidebar` },
  sidebarContent: { selector: `${base}:content` },
  logoutButton: { selector: `${base}:logoutButton` },
};
